// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"493dfb91","155":"6eb9ffa8","223":"3ee1a7d5","453":"4e123eee","953":"8fa4f7fb","995":"6bea8c51"}[chunkId] + ".chunk.js";
};